import { TourAndGalleryReducerState } from '../app-state-types/reducer-state-types/tour-and-gallery';
import {
  TourAndGalleryAction,
  TourAndGalleryActionTypes,
} from '../components-bl/TourAndGallery/Actions/types';

const initialState: TourAndGalleryReducerState = {
  settings: null,
  isLoading: false,
};

export function tourAndGalleryReducer(
  state: TourAndGalleryReducerState = initialState,
  action?: TourAndGalleryAction
): TourAndGalleryReducerState {
  switch (action?.type) {
    case TourAndGalleryActionTypes.GetSettingsRequest:
      return { ...state, isLoading: true };

    case TourAndGalleryActionTypes.GetSettingsSuccess:
      return { ...state, isLoading: false, settings: action.payload.settings };

    case TourAndGalleryActionTypes.GetSettingsError:
      return { ...state, isLoading: false };

    case TourAndGalleryActionTypes.UpdateSettingsRequest:
      return { ...state, isLoading: true };

    case TourAndGalleryActionTypes.UpdateSettingsSuccess:
      return { ...state, isLoading: false, settings: action.payload.settings };

    case TourAndGalleryActionTypes.UpdateSettingsError:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
